import { css } from "@/utils/css";
import { __ } from "@wordpress/i18n";
import { v4 as uuid } from "uuid";

type Props = {
    label?: string;
    help?: string;
    value?: number;
    min?: number;
    max?: number;
    step?: number;
    onChange?: (value: number) => void;
    placeholder?: string;
    className?: string;
};

export function NumberInput({ label, help, value, onChange, placeholder, min, max, className }: Props) {
    const id = uuid();

    return (
        <label htmlFor={id} className={css(className || "")}>
            <span className={css("form-label")}>{label}</span>
            <input
                id={id}
                type="number"
                className={css("form-input")}
                value={value ?? ""}
                onChange={(e) => onChange?.(Number(e.target.value))}
                min={min}
                max={max}
                placeholder={placeholder || __("Type here...", "antimanual")}
            />
            {help && <p className={css("form-help")}>{help}</p>}
        </label>
    );
}
